__turbopack_context__.v({
  "fade-in": "BlockFoodServiceProductList-module-scss-module__mrzXmG__fade-in",
  "landscape": "BlockFoodServiceProductList-module-scss-module__mrzXmG__landscape",
  "listItem": "BlockFoodServiceProductList-module-scss-module__mrzXmG__listItem",
  "productList": "BlockFoodServiceProductList-module-scss-module__mrzXmG__productList",
});
